import { creditCardFormStateSelector } from '../../selectors'

import CreditCardBrandSelect from './CreditCardBrandSelect'
import CreditCardForm from './CreditCardForm'
import './styles.scss'

const IFRAME_NAME = 'ingenico'

const AddCreditCard = ({ verifying3DSecure, errors }) => (
    <div className="add-credit-card">
        {verifying3DSecure ? (
            <p>
                <T>dashboard.label.waiting.3dsecure.response</T>
            </p>
        ) : (
            <div>
                <CreditCardBrandSelect iframeName={IFRAME_NAME} />
                <CreditCardForm iframeName={IFRAME_NAME} />
                {errors && errors.length > 0 && (
                    <div className="error-message">
                        <T>ingenico.creditcard.add.error</T>
                    </div>
                )}
            </div>
        )}
    </div>
)

export default connect(creditCardFormStateSelector)(AddCreditCard)
